module.exports = __webpack_public_path__ + "static/media/agrtucal-excample.ddd2a7d5.png";